<template>
  <transition
    enter-active-class="transition duration-100 ease-out"
    enter-class="transform scale-95 opacity-0"
    enter-to-class="transform scale-100 opacity-100"
    leave-active-class="transition duration-75 ease-in"
    leave-class="transform scale-100 opacity-100"
    leave-to-class="transform scale-95 opacity-0"
  >
    <div
      v-if="isOpen"
      :class="[customClass, setPosition, setAbsolute, {'dark:bg-darkblue-900 dark:divide-gray-500 dark:border-darkblue-600': autoDarkMode}, {'border-primary-300': !autoDarkMode}]"
      :style="[customStyle, dropdownStyles]"
      @click="setAutoClose"
      class="text-secondary mt-2 bg-white dark:bg-darkblue-900 border divide-y divide-gray-100 dark:divide-gray-500 dark:border-darkblue-600 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-auto"
      role="menu"
    >
      <slot />
      <util-keys @keyup.esc="escDropdown" />
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'dropwdown-base',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: [Array, String, Object],
      default: 'w-56'
    },
    customStyle: {
      type: [Array, String, Object],
      default: ''
    },
    position: {
      type: String,
      default: 'top-left'
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: true
    },
    autoDarkMode: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    setPosition: function () {
      return {
        'origin-bottom-right right-0': this.position === 'bottom-right',
        'origin-bottom-right right-[-75px]': this.position === 'bottom-right-75',
        'origin-top-left left-0': this.position === 'top-left',
        'origin-top-right right-0': this.position === 'top-right',
        'origin-center left-0': this.position === 'center'
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        '': this.mode === 'tools',
      }
    },
    setAbsolute: function () {
      return {
        absolute: this.absolute === true,
        '': this.absolute === false
      }
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    dropdownStyles: function () {
      if (this.isLower1024) {
        return { maxHeight: 'calc(100vh - 8rem)' }
      }
      return { maxHeight: 'calc(100vh - 12rem)' }
    }
  },
  methods: {
    setAutoClose: function () {
      if (this.autoClose) this.escDropdown()
    },
    escDropdown: function () {
      this.$emit('toggle')
    }
  }
}
</script>
